import { integrationApi } from "api/TenantSlug/Integration/api.ts";
import { useSelectOptions } from "components/UI/Selects/SearchableSelect/hooks/useSelectOptions.ts";

import IntegrationData = App.Data.IntegrationData;

export const useIntegrationSelectOptions = () => {
    return useSelectOptions<IntegrationData>({
        apiFunction: (payload) => integrationApi.index(payload),
        dataKey: "integrations",
        cacheKey: "integration-select",
        mapToOption: (integration) => ({
            label: integration.name,
            value: integration.id ?? "",
        }),
    });
};